const mustache = require("mustache");
let faqBlocks = [];
let faqButtons = [];

export const faq = {
    onDocumentLoad
}

const onDocumentLoad = function() {
  /*FAQ*/
  faqBlocks = document.getElementsByClassName("faq-block");
  for (let i = 0; i < faqBlocks.length; i++) {
    faqButtons = faqBlocks[i].getElementsByTagName("button");
    for (let i = 0; i < faqButtons.length; i++) {
      let expand = document.getElementById(
        faqButtons[i].getAttribute("aria-controls")
      );
      let height = expand.offsetHeight;
      expand.setAttribute("data-height", height);
      expand.style.height = 0;

      faqButtons[i].addEventListener("click", function (e) {
        faqButtonClick(e.currentTarget);
      });
    }
  }

  function faqButtonClick(target) {
    target.setAttribute("aria-expanded", toggleAriaExpanded(target));

    let expand = document.getElementById(target.getAttribute("aria-controls"));
    expand.classList.toggle("open");

    if (expand.classList.contains("open")) {
      expand.style.height = expand.dataset.height + "px";
    } else {
      expand.style.height = 0;
    }
  }

  function toggleAriaExpanded(target) {
    let targetExpanded = target.getAttribute("aria-expanded");

    if (targetExpanded == "true") {
      targetExpanded = "false";
    } else {
      targetExpanded = "true";
    }

    return targetExpanded;
  }
}